export default __webpack_public_path__ + "static/media/social-bubbles.ed031c65.png";